import { render, staticRenderFns } from "./SectionMoney.vue?vue&type=template&id=734fe73a&scoped=true&"
import script from "./SectionMoney.vue?vue&type=script&lang=js&"
export * from "./SectionMoney.vue?vue&type=script&lang=js&"
import style0 from "./SectionMoney.vue?vue&type=style&index=0&id=734fe73a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734fe73a",
  null
  
)

export default component.exports